export default "__VITE_ASSET__CKNGPApr__"